export const ROUTES = {
  APP: 'app',
  HOME: 'home',

  TICKETS: 'request',
  TICKET_EDIT: 'request-edit',

  APPROVALS: 'approval',
  CONFIRMATIONS: 'confirmation',
  POLICIES: 'policy',

  SETTINGS: 'settings',
  SETTINGS_DETAILS: 'settings-details',
  SETTINGS_INTEGRATIONS: 'settings-integrations',
  SETTINGS_NOTIFICATIONS: 'settings-notifications',

  FAQ: 'faq',
  /** Help Center topic: /faq/:topicId */
  FAQ_TOPIC: 'faq-topic',
  /** Help Center article: /faq/:topicId/:articleId */
  FAQ_ARTICLE: 'faq-article',

  NOTIFICATIONS_POC: 'dev-notifications',
  ERROR_POC: 'dev-errors',

  /** Unknown URL. Outside the app shell, so auth must not send the user away. */
  NOT_FOUND: 'not-found',
}

/** Named routes that belong to the in-app Help Center (header title, etc.) */
export const FAQ_ROUTES = [ROUTES.FAQ, ROUTES.FAQ_TOPIC, ROUTES.FAQ_ARTICLE]

// The address bar is already the typed URL while the first navigation is still the nameless start route.
export function isNotFoundLocation(router) {
  const current = router.currentRoute.value
  if (current.name === ROUTES.NOT_FOUND) return true
  if (current.name) return false
  return router.resolve(window.location.pathname).name === ROUTES.NOT_FOUND
}
